import { render, staticRenderFns } from "./locationManage.vue?vue&type=template&id=3543a588&scoped=true"
import script from "./locationManage.vue?vue&type=script&lang=js"
export * from "./locationManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543a588",
  null
  
)

export default component.exports